import request from "@utils/request";

export function getTradeOnCredit(query) {
    return request({
        url: 'alert/data/trade-on-credit',
        method: 'get',
        params: query
    })
}
